module.exports = __webpack_public_path__ + "static/media/checkbox_off.9d3dc337.svg";